import Vue from 'vue';
import { FacetsGroups, FacetState, SearchState } from '../../../models';
import { Dictionary } from '../../../utils';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export interface AddFacetsToGroupPayload {
  groupId: string;
  facets: Dictionary<FacetState>;
}

export class SetFacetsGroupsMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.setFacetsGroups]: (searchState: SearchState, facetsGroups: FacetsGroups) => {
      searchState.facetsGroups = facetsGroups;
    },
    [SEARCH_MUTATIONS_KEYS.addFacetsToGroup]: (searchState: SearchState, { groupId, facets }: AddFacetsToGroupPayload) => {
      const stateFacets = searchState.facetsGroups[groupId]?.facets;

      if (stateFacets) {
        Object.entries(facets).forEach(([facetName, facetState]) => {
          if (stateFacets[facetName]) {
            stateFacets[facetName] = facetState;
          } else {
            Vue.set(stateFacets, facetName, facetState);
          }
        });
      }
    }
  };
}
